import type { Airline, FlightArrival, FlightDeparture, FlightSchedule } from "../my-type";
import { authUserData } from ".";
import {
  TdxService as GeneratedTdxService,
  callApi,
  configureApiClient,
} from "../api/client";

const configureTdxApiClient = () => {
  configureApiClient({
    tokenProvider: () => authUserData()?.jwtToken ?? null,
  });
};


export const getFightSchedule = async (IataNo: string, flightNo: string, checkDateTime: Date, isInternational: boolean) => {
  try {
    configureTdxApiClient();
    let checkDate = checkDateTime.toLocaleDateString('zh-TW', { year: 'numeric', month: '2-digit', day: '2-digit' });
    checkDate = checkDate.replaceAll('/', '-');
    const data = await callApi(
      () =>
        GeneratedTdxService.getApiTdxQueryFlightSchedule(
          IataNo,
          flightNo,
          checkDate,
          isInternational
        ),
      "Failed to query flight schedule"
    );
    return data as FlightSchedule[];

  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getAirlines = async () => {
  try {
    configureTdxApiClient();
    const data = await callApi(
      () => GeneratedTdxService.getApiTdxAirlines(),
      "Failed to query airlines"
    );
    return data as Airline[];
  } catch (error) {
    console.log(error);
    return null;
  }

};

export const getFlightDepartureInfo = async (airportCode: string) => {
  try {
    configureTdxApiClient();
    const data = await callApi(
      () => GeneratedTdxService.getApiTdxFlightDepartureInfo(airportCode),
      "Failed to query departure info"
    );
    return data as FlightDeparture[];
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getFlightArrivalInfo = async (airportCode: string) => {
  try {
    configureTdxApiClient();
    const data = await callApi(
      () => GeneratedTdxService.getApiTdxFlightArrivalInfo(airportCode),
      "Failed to query arrival info"
    );
    return data as FlightArrival[];
  } catch (error) {
    console.log(error);
    return null;
  }
};
